import { Column, Row, Stack } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export interface IParentAdminRowWrapperProps {
  children: React.ReactNode;
}

export function ParentAdminRowWrapper({
  children,
}: IParentAdminRowWrapperProps): JSX.Element {
  return (
    <Stack borderBottom="1px solid" borderColor="lightLine">
      <Row>
        <Column role="cell">{children}</Column>
      </Row>
    </Stack>
  );
}
